import React, { useState, useEffect } from "react";
import { Modal, Button, TextBox, Select, Checkbox } from "@veneer/core";
import { Row, Col } from "react-bootstrap";

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  initialData?: any;
  bindPin?: any[];
  countryList?: any[];
}

const AddressModal: React.FC<Props> = ({
  show,
  onClose,
  onSave,
  initialData,
  bindPin = [],
  countryList = []
}) => {
  const toArray = (val: any) => (Array.isArray(val) ? val : val ? [val] : []);

  const [form, setForm] = useState<any>({
    BindingPin: [],
    company: "",
    AddressLine1: "",
    AddressLine2: "",
    Mailstop: "",
    City: "",
    State: "",
    ZipCode: "",
    country: [],
    Acknowledge: ""
  });

  useEffect(() => {
    if (!initialData) return;
    
    
    setForm({
      ...initialData,
      BindingPin: toArray(initialData?.BindingPin),
      // Handle multiple possible country field names from API
      country: initialData?.country || initialData?.Country || initialData?.countryId || initialData?.countryName
    });
  }, [initialData, countryList]);


  const update = (k: string, v: any) =>
    setForm((prevdata: any) => ({ ...prevdata, [k]: v }));

  const updateSelect = (k: string, opt: any) =>
  {
    update(k, opt?.value ? [opt.value] : []);
    if (k === 'country'){
      
      update(k, opt?.value ? opt.value : "");
    }
    
  }
   
const BindingPinList = bindPin.map((p: any) => ({
  label: p.Value,
  value: p.Key
}));
  return (
    <Modal show={show} onClose={onClose} title="Equipment Address" expanded>
      <form >
        <Row >
          <Col md={6}>
            <TextBox
              separateLabel
              label="Company"
              value={form.company}
              onChange={(v: any) => update("company", v)}
            />
          </Col>
          {bindPin?.length > 0 && (
            <Col md={6}>
              <Select
                separateLabel
                label="Pin"
                options={BindingPinList}
                value={toArray(form.BindingPin)}
                onChange={(opt: any) => updateSelect("BindingPin", opt)}
              />
            </Col>
          )}
          </Row>
          <Row>

          <Col md={6}>
            <TextBox
              separateLabel
              label="Address Line 1"
              value={form.AddressLine1}
              onChange={(v: any) => update("AddressLine1", v)}
            />
          </Col>

          <Col md={6}>
            <TextBox
              separateLabel
              label="Address Line 2"
              value={form.AddressLine2}
              onChange={(v: any) => update("AddressLine2", v)}
            />
          </Col>
          </Row>
          <Row>

          <Col md={6}>
            <TextBox
              separateLabel
              label="City"
              value={form.City}
              onChange={(v: any) => update("City", v)}
            />
          </Col>

          <Col md={6}>
            <TextBox
              separateLabel
              label="State"
              value={form.State}
              onChange={(v: any) => update("State", v)}
            />
          </Col>
          </Row>
          <Row>

          <Col md={6}>
            <TextBox
              separateLabel
              label="Zip Code"
              value={form.ZipCode}
              onChange={(v: any) => update("ZipCode", v)}
            />
          </Col>

          <Col md={6}>
            <Select
              separateLabel
              label="Country"
              options={countryList || []}
              value={toArray(form.country)}
              onChange={(opt: any) => updateSelect("country", opt)}
              showSearch
              placeholder="Select a country"
              clearIcon={true}
            />
          </Col>
          </Row>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 20 }}>
          <Button appearance="secondary" onClick={onClose}>Cancel</Button>
          <Button type="button" onClick={() => onSave(form)}>Save</Button>
        </div>

      </form>
    </Modal>
  );
};

export default AddressModal;
